module.exports = __webpack_public_path__ + "static/media/CV-elvira-fuente.c8579a9d.pdf";